import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Sidebar from './components/Sidebar/Sidebar';
import Box from './containers/Box/Box';
import CropTablePage from './containers/CropTablePage/CropTablePage';
import Footer from './components/Footer/Footer';
function App() {
  const [showCropTable, setShowCropTable] = useState(false);

  // Function to show the crop table
  const showCropTablePage = () => {
    setShowCropTable(true);
  };

  // Function to hide the crop table and show the boxes
  const hideCropTablePage = () => {
    setShowCropTable(false);
  };
  const crops = [
    // List of crops (same as in your provided JavaScript code)
    { name: "Wheat", constant: 14.7 },
      { name: "Maize", constant: 14.7 },
      { name: "Sorghum", constant: 14.7 },
      { name: "Bajra", constant: 14.7 },
      { name: "Barley", constant: 14.7 },
      { name: "Oats", constant: 14.7 },
      { name: "Paddy_(not_shelled_rice)", constant: 14.7 },
      { name: "Mash", constant: 14.7 },
      { name: "Moong", constant: 14.7 },
      { name: "Lentil", constant: 14.7 },
      { name: "Arhar", constant: 14.7 },
      { name: "Peas", constant: 14.7 },
      { name: "Soybean", constant: 25.0 },
      { name: "Sesame", constant: 25.0 },
      { name: "Rape seed", constant: 25.0 },
      { name: "Mustard", constant: 25.0 },
      { name: "Linseed", constant: 25.0 },
      { name: "Sunflower", constant: 25.0 },
      { name: "Sugarcane", constant: 5.3 },
      { name: "Sweet_potato", constant: 5.6 },
      { name: "Tapioca", constant: 5.6 },
      { name: "Potato", constant: 3.6 },
      { name: "Beet_root", constant: 3.6 },
      { name: "Colacasia", constant: 3.6 },
      { name: "Broad_beans", constant: 1.9 },
      { name: "Clusterbeans", constant: 1.9 },
      { name: "Ladyfinger", constant: 1.9 },
      { name: "Muskmelon", constant: 1.9 },
      { name: "Watermelon", constant: 1.9 },
      { name: "Cucumber_family", constant: 0.8 },
      { name: "Drumstick_giant", constant: 0.8 },
      { name: "Green_papaya", constant: 0.8 },
      { name: "Pumpkin", constant: 0.8 },
      { name: "Tomato", constant: 0.8 },
      { name: "Chillies", constant: 0.8 },
      { name: "Cabbage", constant: 0.8 },
      { name: "Spinach", constant: 0.8 },
      { name: "Green_mustard_leaves", constant: 0.8 },
      { name: "Cotton", constant: 11.8 },
      { name: "Sunnhemp", constant: 11.8 },
      { name: "Jute", constant: 11.8 },
      { name: "Berseem", constant: 18.0 },
      { name: "Lucerne", constant: 18.0 },
      { name: "Senji", constant: 18.0 },
      { name: "Cowpea", constant: 18.0 },
      { name: "Guara", constant: 18.0 },
      { name: "Napier", constant: 18.0 },
      { name: "Tamarind", constant: 18.0 },
      { name: "Grapes", constant: 18.0 },
      { name: "Guava", constant: 18.0 },
      { name: "Mango", constant: 11.8 },
      { name: "Amla", constant: 11.8 },
      { name: "Apple", constant: 1.9 },
      { name: "Peach", constant: 1.9 },
      { name: "Pears", constant: 1.9 },
      { name: "Pineapples", constant: 1.9 },
      { name: "Ber", constant: 1.9 },
      { name: "Sapotta", constant: 1.9 },
      { name: "Cashew", constant: 1.9 },
      { name: "Citrus", constant: 1.9 }
  ];

  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          {/* Define the Route for the CropTablePage component */}
          <Route
            path="/table/:selectedCrop"
            element={<CropTablePage onHideCropTable={hideCropTablePage} />}
          />
        </Routes>
        <Sidebar crops={crops}/>
        {/* Conditionally render the Box based on the state */}
        {!showCropTable ? <Box onShowCropTable={showCropTablePage} /> : null} 
        <Footer />
      </div>
    </Router>
  );
}

export default App;